import React, { useContext } from "react"
import { Link, useLocation } from "react-router-dom"

import { Button } from "../../components/common/button/Button"
import { Seperator } from "../../components/common/seperator/seperator"
import VehicleInfoContainer from "../../components/common/VehicleInfoContainer/VehicleInfoContainer"
import { AppContext, AppContextInterface } from "../../state/ContextProvider"
import { checkPath } from '../../utils/validation-utils'

const CallRequestedConfirmation: React.FC = () => {
  const { search } = useLocation()
  const {
    actions: { resetState },
  } = useContext(AppContext) as AppContextInterface

  return (
    <div className="appointment-confirmation-container call-requested-container">
      <VehicleInfoContainer />
      <div className="heading-container">
        <h2 className="confirmation-details-heading">Call Requested!</h2>
      </div>
      <div className="inner-container">
        <p className="confirmation-details-paragraph">
          Thank you for your enquiry. A member of the team will call you back
          within one hour during our operating hours, to discuss your options.
        </p>
        <div className="button-container">
          <Seperator />
          <Link className="text-link" to={checkPath(search)}>
            <Button onClick={() => resetState()} type="button" variant="blue" id="value-another-vehicle">
              VALUE ANOTHER VEHICLE
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default CallRequestedConfirmation
